const iconPalette = (tokens) => {
    return {
        size: {
            micro: tokens.iconSizeMicro,
            xxsmall: tokens.iconSizeXxs,
            xsmall: tokens.iconSizeXs,
            small: tokens.iconSizeS,
            medium: tokens.iconSizeM,
            large: tokens.iconSizeL,
            xlarge: tokens.iconSizeXl,
            xxlarge: tokens.iconSizeXxl
        },
        static: {
            neutral: {
                color: {
                    default: tokens.iconColorStaticNeutral,
                    error: tokens.iconColorErrorNeutral,
                    warning: tokens.iconColorWarningNeutral,
                    info: tokens.iconColorInfoNeutral,
                    success: tokens.iconColorSuccessNeutral
                }
            },
            emphasis: {
                color: {
                    default: tokens.iconColorStaticEmphasis,
                    error: tokens.iconColorErrorNeutral,
                    warning: tokens.iconColorWarningNeutral,
                    info: tokens.iconColorInfoNeutral,
                    success: tokens.iconColorSuccessNeutral
                }
            },
            subtle: {
                color: {
                    default: tokens.iconColorStaticSubtle,
                    error: tokens.iconColorErrorSubtle,
                    warning: tokens.iconColorWarningSubtle,
                    info: tokens.iconColorInfoSubtle,
                    success: tokens.iconColorSuccessSubtle
                }
            }
        },
        interactive: {
            neutral: {
                color: {
                    default: tokens.iconColorInteractiveComponentNeutralDefault,
                    hover: tokens.iconColorInteractiveComponentNeutralHover,
                    focus: tokens.iconColorInteractiveComponentNeutralFocus,
                    disabled: tokens.iconColorInteractiveComponentNeutralDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentNeutralSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentNeutralSelectedHover
                    }
                }
            },
            emphasis: {
                color: {
                    default: tokens.iconColorInteractiveComponentEmphasisDefault,
                    hover: tokens.iconColorInteractiveComponentEmphasisHover,
                    focus: tokens.iconColorInteractiveComponentEmphasisFocus,
                    disabled: tokens.iconColorInteractiveComponentEmphasisDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentEmphasisSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentEmphasisSelectedHover
                    }
                }
            },
            subtle: {
                color: {
                    default: tokens.iconColorInteractiveComponentSubtleDefault,
                    hover: tokens.iconColorInteractiveComponentSubtleHover,
                    focus: tokens.iconColorInteractiveComponentSubtleFocus,
                    disabled: tokens.iconColorInteractiveComponentSubtleDisabled,
                    selected: {
                        default: tokens.iconColorInteractiveComponentSubtleSelectedDefault,
                        hover: tokens.iconColorInteractiveComponentSubtleSelectedHover
                    }
                }
            }
        },
        error: {
            neutral: {
                color: tokens.iconColorErrorNeutral
            }
        },
        warning: {
            neutral: {
                color: tokens.iconColorWarningNeutral
            }
        },
        success: {
            neutral: {
                color: tokens.iconColorSuccessNeutral
            }
        },
        info: {
            neutral: {
                color: tokens.iconColorInfoNeutral
            }
        }
    };
};
export default iconPalette;
//# sourceMappingURL=icon.js.map